"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinwheelRequestType = exports.DepositPinwheelDirectDepositSwitchStatus = void 0;
var DepositPinwheelDirectDepositSwitchStatus;
(function (DepositPinwheelDirectDepositSwitchStatus) {
    DepositPinwheelDirectDepositSwitchStatus["linkTokenCreated"] = "link_token_created";
    /** Link reported the user finished the flow, but Pinwheel has not yet published a job for it. */
    DepositPinwheelDirectDepositSwitchStatus["switchSubmitted"] = "switch_submitted";
    DepositPinwheelDirectDepositSwitchStatus["switchPending"] = "switch_pending";
    DepositPinwheelDirectDepositSwitchStatus["switchSucceeded"] = "switch_succeeded";
    DepositPinwheelDirectDepositSwitchStatus["switchFailed"] = "switch_failed";
})(DepositPinwheelDirectDepositSwitchStatus || (exports.DepositPinwheelDirectDepositSwitchStatus = DepositPinwheelDirectDepositSwitchStatus = {}));
var PinwheelRequestType;
(function (PinwheelRequestType) {
    PinwheelRequestType["createLinkToken"] = "create_link_token";
    PinwheelRequestType["getJobs"] = "get_jobs";
    PinwheelRequestType["getAllocations"] = "get_allocations";
    PinwheelRequestType["webhookInbound"] = "webhook_inbound";
})(PinwheelRequestType || (exports.PinwheelRequestType = PinwheelRequestType = {}));
